<script>
    import { onMount } from 'svelte';
    import PublicNavbar from "../components/PublicNavbar.svelte"
    import Navbar from "../components/Navbar.svelte"
    import { firebase } from "../firebase/firebase.js";

    export let currentRoute;
    export let params;

    let firstName = '';
    let lastName = '';
    let email = '';
    let comment = '';
    let loading = false;

    let successMessage = '';
    let warningMessage = '';
    let errorMessage = '';

    function sendEmail() {
        successMessage = '';
        warningMessage = '';
        errorMessage = '';
        if (validateEntries()) {
            loading = true;
            var mail = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                comment: comment,
            }

            setTimeout(() => {
                successMessage = 'We received your message. we will reply you soon.'
                loading = false;
            }, 3000);
            // var sendMail = firebase.functions().httpsCallable('sendMail');
            // sendMail(mail)
            //     .then(async (result) => {
            //         console.log('sucess')
            //         console.log(result)
            //         successMessage = 'Your message was sent to us, we will reply you soon.'
            //     })
            //     .catch(error => {
            //         console.log('error');
            //         console.log(error);
            //         if (error && error.message) {
            //             errorMessage = error.message
            //         } else {
            //             errorMessage = 'Failed to send your comment, Please try again'
            //         }
            //         loading = false;
            //     })
            //     .finally(() => {
            //         loading = false;
            //     });
        } else {
            errorMessage = 'Something is missing'
        }
    }

    function validateEntries() {
        if (!firstName || !firstName.length) {
            warningMessage = 'First name is required';
            return false;
        } else if (!email || !email.length) {
            warningMessage = 'Email is required';
            return false;
        } else if (!validateEmail(email)) {
            warningMessage = 'Email is invalid';
            return false;
        } else if (!comment || !comment.length) {
            warningMessage = 'Please write your comment';
            return false;
        }
        return true;
    }

    function validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
</script>

<PublicNavbar showLogin={true} showSupport={false} />
<div class="container">
    <div class="row d-flex support-form w-100">
        <div class="col-md-9">
            {#if errorMessage}
                <div class="py-4 alert alert-danger alert-dismissible fade show" role="alert">
                    <strong>Alert!</strong> {errorMessage}
                </div>
            {/if}
            {#if warningMessage}
                <div class="py-4 alert alert-warning fade show" role="alert">
                    <strong>Warning! </strong> {warningMessage}
                </div>
            {/if}
            {#if successMessage}
                <div class="py-4 alert alert-success fade show" role="alert">
                    <strong>Success! </strong> {successMessage}
                </div>
            {/if}
            <div class="form_head">
                <h2>Support Form</h2>
                <br>
                <p>We would love to hear from you!</p>
            </div>
            <form class="contact-form" onsubmit="return false">
                <div class="form-group mb-20">
                    <label style="padding-bottom: 10px;" class="control-label col-sm-2" for="fname">First Name:</label>
                    <div class="col-sm-10">
                        <input bind:value={firstName} type="text" class="form-control" id="fname"
                            placeholder="First Name" name="fname">
                    </div>
                </div>
                <div class="form-group mb-20">
                    <label style="padding-bottom: 10px;" class="control-label col-sm-2" for="lname">Last Name:</label>
                    <div class="col-sm-10">
                        <input bind:value={lastName} type="text" class="form-control" id="lname" placeholder="Last Name"
                            name="lname">
                    </div>
                </div>
                <div class="form-group mb-20">
                    <label style="padding-bottom: 10px;" class="control-label col-sm-2" for="email">Email:</label>
                    <div class="col-sm-10">
                        <input bind:value={email} type="email" class="form-control" id="email" placeholder="Email"
                            name="email">
                    </div>
                </div>
                <div class="form-group mb-20">
                    <label style="padding-bottom: 10px;" class="control-label col-sm-2" for="comment">Comment:</label>
                    <div class="col-sm-10">
                        <textarea bind:value={comment} class="form-control" rows="5" id="comment"></textarea>
                    </div>
                </div>
                <div class="form-group mb-20">
                    <div class="col-sm-offset-2 col-sm-10">
                        {#if loading}
                        <button class="btn btn-default">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="sr-only">Loading...</span>
                        </button>
                        {:else}
                            <button on:click={sendEmail} class="btn btn-default">Send Email</button>
                        {/if}
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<style>
    .support-form {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .form_head {
        margin-left: 12px;
        margin-bottom: 50px;
    }

    body {
        background-color: #25274d;
    }

    .contact {
        padding: 4%;
        height: 400px;
    }

    .col-md-3 {
        background: #ff9b00;
        padding: 4%;
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
    }

    .contact-info {
        margin-top: 10%;
    }

    .contact-info img {
        margin-bottom: 15%;
    }

    .contact-info h2 {
        margin-bottom: 10%;
    }

    .col-md-9 {
        background: #fff;
        padding: 3%;
        border-top-right-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
    }

    .contact-form label {
        font-weight: 600;
    }

    .contact-form button {
        background: #25274d;
        color: #fff;
        font-weight: 600;
        width: 25%;
    }

    .contact-form button:focus {
        box-shadow: none;
    }
</style>